'use client'

import { SWRConfig } from 'swr'

type SWRHydrateProps = {
  fallback: Record<string, unknown>
  children: React.ReactNode
}

/**
 * 서버에서 받아온 데이터를 SWR 캐시에 주입한다.
 *
 * fallback만 제공한다. useCachedSWR은 같은 키의 성공한 서버 응답이 있으면
 * 첫 mount 요청을 생략하고, 데이터가 없으면 STATIC을 포함해 처음 요청한다.
 * 이후 focus/reconnect 및 명시적 mount override는 호출부 정책을 따른다.
 */
export default function SWRHydrate({ fallback, children }: SWRHydrateProps) {
  return <SWRConfig value={{ fallback }}>{children}</SWRConfig>
}
